import { HeaderContext } from 'app/Contexts/HeaderProvider'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { Footer } from '../shared/Footer'
import { HeaderWave } from '../shared/HeaderWave'
import { TopMenu } from '../shared/TopMenu'

export const Layout: React.FC = ({ children }) => {
  const headerCtx = useContext(HeaderContext)

  return (
    <>
      <TopMenu></TopMenu>
      <HeaderWave
        title={headerCtx?.headerTitle}
        subtitle={headerCtx?.headerSubTitle}
        subtitleVariant={headerCtx?.subTitleVariant}
        variant='curva-scemplice-verso-alto'
      ></HeaderWave>
      <BodyWrapper>{children}</BodyWrapper>
      <Footer></Footer>
    </>
  )
}

const BodyWrapper = styled.div`
  margin-top: 2rem;
  margin-bottom: 6rem;
`
